import { render } from "./Index.vue?vue&type=template&id=53d37b0f"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Employees/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53d37b0f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53d37b0f', __exports__)) {
    console.log('reload')
    api.reload('53d37b0f', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=53d37b0f", () => {
    console.log('re-render')
    api.rerender('53d37b0f', render)
  })

}


export default __exports__